var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { timer } from 'rxjs/observable/timer';
var Singlegatewaywait3Component = /** @class */ (function () {
    function Singlegatewaywait3Component(router, Util, Api) {
        this.router = router;
        this.Util = Util;
        this.Api = Api;
        this.isCompany = false;
        this.isProcressSuccess = true;
        this.telephoneOtp = "";
        this.otp = "";
        this.isCrisis = true;
        this.ref_id = "";
        this.citizenid = "";
        this.dpa_portal = {};
        this.ContactData = {};
        this.timeLeft = 3600;
        this.message = "";
    }
    Singlegatewaywait3Component.prototype.ngOnInit = function () {
        var btn = document.querySelector('.btn');
        btn.addEventListener('click', function () {
            console.log("a");
        });
        //this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal")); 
        //this.InvestigateAndAppealCondition(this.PortalUser.contactid);
        this.InvestigateAndAppealCondition(null);
        this.startTimer();
        this.startTimer2();
    };
    Singlegatewaywait3Component.prototype.InvestigateAndAppealCondition = function (UID) {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, drosWeb, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        drosWeb = '';
                        return [4 /*yield*/, this.Api.post("crmservice", "getUrlSingleGateway", { UID: UID })];
                    case 1:
                        result = _a.sent();
                        if (!this.Util.IsNullOrUndefined(result)) {
                            if (!this.Util.IsNullOrUndefined(result.authorizationUrl)) {
                                console.log(result);
                                drosWeb = result.authorizationUrl;
                                localStorage.setItem("referenceId", result.referenceId);
                                this.ref_id = result.referenceId;
                                //this.citizenid = result.dpa_citizenid;
                                this.accessToken = result.token;
                                window.open(drosWeb, "_blank");
                            }
                            else {
                                this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                                thisTs.router.navigate(["mainmenu/index"]);
                            }
                        }
                        else {
                            this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
                            thisTs.router.navigate(["mainmenu/index"]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Singlegatewaywait3Component.prototype.startTimer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var source;
            return __generator(this, function (_a) {
                source = timer(1000, 2000);
                this.abc = source.subscribe(function (val) {
                    if (val < 3600) {
                        _this.message = _this.dhms(_this.timeLeft - val);
                    }
                    else {
                        var thisTs = _this;
                        _this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
                        thisTs.router.navigate(["mainmenu/index"]);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    Singlegatewaywait3Component.prototype.startTimer2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var source2;
            return __generator(this, function (_a) {
                source2 = timer(3000, 6000);
                this.abc2 = source2.subscribe(function (val) {
                    //this.ref_id = localStorage.getItem("referenceId");
                    //this.ref_id = '9f9998459f654733';
                    if (_this.ref_id != "") {
                        var para = "refId=" + _this.ref_id + "&token=" + _this.accessToken;
                        _this.Api.get("crmservice", "GetDataSingleGatewayLog", para).then(function (ContactRes) {
                            console.log(ContactRes);
                            _this.ContactData = ContactRes;
                            if (ContactRes.dpa_result !== undefined) {
                                if (_this.isProcressSuccess == ContactRes.procress) {
                                    if (ContactRes.dpa_result == 'Y') {
                                        if (ContactRes.dpa_contactid != null && ContactRes.dpa_contactid != "" && ContactRes.dpa_contactid != undefined) {
                                            _this.Login();
                                        }
                                        else {
                                            var thisTs = _this;
                                            _this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");
                                            thisTs.router.navigate(["/mainmenu/index"]);
                                        }
                                        //let thisTs = this;
                                        //this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");  
                                        //thisTs.router.navigate(["mainmenu/refundDeposits"]);
                                    }
                                    else if (ContactRes.dpa_result == 'R') {
                                        sessionStorage.setItem("dpa_portalThaiID", JSON.stringify(_this.ContactData));
                                        _this.router.navigate(["mainmenu/register"], { queryParams: { regisType: "n" } });
                                    }
                                    else if (ContactRes.dpa_result == 'N') {
                                        var thisTs = _this;
                                        _this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");
                                        thisTs.router.navigate(["/mainmenu/index"]);
                                    }
                                    else if (ContactRes.dpa_result == 'CM') {
                                        var thisTs = _this;
                                        _this.Util.WarningDialog("ไม่สามารถเข้าสู่ระบบได้ เนื่องจากท่านยังไม่ได้ยืนยันการลงทะเบียนทางอีเมล");
                                        thisTs.router.navigate(["/mainmenu/index"]);
                                    }
                                    else {
                                        //let thisTs = this;
                                        //this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณาทำการยืนยันตัวตนอีกครั้ง โดยใช้หมายเลขบัตรประชาชน หรือหมายเลขโทรศัพท์ที่ท่านได้ทำการลงทะเบียนไว้");  
                                        //thisTs.router.navigate(["mainmenu/refundDeposits"]);
                                    }
                                }
                            }
                            //else{
                            //  let thisTs = this;
                            //  this.Util.ErrorDialog("ไม่พบข้อมูลการลงทะเบียนของท่าน  กรุณาติดต่อ DPA Call Center 1158");  
                            //  thisTs.router.navigate(["/mainmenu/index"]);
                            //}
                        });
                    }
                    var btn = document.querySelector('.btn');
                    var clickEvent = new Event('click');
                    btn.dispatchEvent(clickEvent);
                });
                return [2 /*return*/];
            });
        });
    };
    Singlegatewaywait3Component.prototype.dhms = function (t) {
        var minutes, seconds;
        minutes = Math.floor(t / 60) % 60;
        t -= minutes * 60;
        seconds = t % 60;
        return [
            minutes + ' นาที',
            seconds + ' วินาที'
        ].join(' ');
    };
    Singlegatewaywait3Component.prototype.ngOnDestroy = function () {
        //prevent memory leak when component destroyed
        this.abc.unsubscribe();
        this.abc2.unsubscribe();
    };
    Singlegatewaywait3Component.prototype.getContactDROS = function (idcard) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false";
                        return [4 /*yield*/, this.Api.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    Singlegatewaywait3Component.prototype.Login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var contact, _a, _b, _c, thisTs_1, thisTs_2, ticket_1, thisTs_3, ex_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 10, , 11]);
                        return [4 /*yield*/, this.Api.get("crmservice", "contact", "contactid=" + this.ContactData.dpa_contactid)];
                    case 1:
                        contact = _d.sent();
                        contact = contact[0];
                        console.log(contact);
                        if (contact == null || contact == undefined) {
                            sessionStorage.setItem("dpa_portalThaiID", JSON.stringify(this.ContactData));
                            this.router.navigate(["mainmenu/register"], { queryParams: { regisType: "n" } });
                        }
                        this.dpa_portal = {
                            firstname: contact.firstname,
                            lastname: contact.lastname,
                            email: contact.emailaddress1,
                            contactid: this.ContactData.dpa_contactid,
                            pid: contact.dpa_idcard,
                            readNewsList: null
                        };
                        if (!this.isCrisis) return [3 /*break*/, 8];
                        if (!(contact.dpa_companytypeid != null && contact.dpa_companytypeid.trim().length > 0)) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_registrationid)];
                    case 2:
                        _a.ContactDros = _d.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(contact.dpa_passport != null && contact.dpa_passport.trim().length > 0)) return [3 /*break*/, 5];
                        _b = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_passport)];
                    case 4:
                        _b.ContactDros = _d.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        _c = this;
                        return [4 /*yield*/, this.getContactDROS(contact.dpa_idcard)];
                    case 6:
                        _c.ContactDros = _d.sent();
                        _d.label = 7;
                    case 7:
                        if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06)) {
                            if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '2') {
                                thisTs_1 = this;
                                this.Util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                                $("#btnWarningOK").click(function () {
                                    thisTs_1.router.navigate(["/mainmenu/index"]);
                                });
                                thisTs_1.router.navigate(["mainmenu/index"]);
                                return [2 /*return*/];
                            }
                            if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '3') {
                                thisTs_2 = this;
                                this.Util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                                $("#btnWarningOK").click(function () {
                                    thisTs_2.router.navigate(["/mainmenu/index"]);
                                });
                                thisTs_2.router.navigate(["mainmenu/index"]);
                                return [2 /*return*/];
                            }
                        }
                        _d.label = 8;
                    case 8:
                        if (contact != null && contact.length > 0) {
                            this.telephoneOtp = contact[0].telephone1;
                        }
                        this.cookieData = this.dpa_portal;
                        localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal));
                        localStorage.setItem("verifyIdentity", "true");
                        return [4 /*yield*/, this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)];
                    case 9:
                        ticket_1 = _d.sent();
                        this.Util.ShowWaiting(false);
                        this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");
                        thisTs_3 = this;
                        $('#btnSuccessOK').on('click', function () {
                            //thisTs.router.navigate(["mainmenu/index"])
                            if (ticket_1 != null && ticket_1.length > 0 && (ticket_1[0].dpa_approvalstatuscode == "01" || ticket_1[0].dpa_approvalstatuscode == "02" || ticket_1[0].dpa_approvalstatuscode == "06")) {
                                var url = thisTs_3.Util.baseUrl() + "/mainmenu/statusDocument/" + thisTs_3.cookieData.contactid;
                                window.open(url, "_blank");
                                //this.showLoginForm = false
                                //this.showOtp = true
                            }
                            else {
                                thisTs_3.Util.ShowWaiting(true);
                                thisTs_3.router.navigate(["mainmenu/refundDeposits"]);
                            }
                        });
                        return [3 /*break*/, 11];
                    case 10:
                        ex_1 = _d.sent();
                        this.Util.ShowWaiting(false);
                        console.log(ex_1);
                        this.Util.ErrorDialog('เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่');
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return Singlegatewaywait3Component;
}());
export { Singlegatewaywait3Component };



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait3/singlegatewaywait3.component.ts.pre-build-optimizer.js